// extracted by mini-css-extract-plugin
module.exports = {"game-wrapper":"Game_game-wrapper__2n7J6","canvas":"Game_canvas__Qr1SX","pushy-container":"Game_pushy-container__2AZ6Y","pushy":"Game_pushy__kY7mo"};